import React from 'react'

const LeftMarkIcon = () => {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.3002 0.69922C6.48353 0.882553 6.5752 1.11589 6.5752 1.39922C6.5752 1.68255 6.48353 1.91589 6.3002 2.09922L2.4002 5.99922L6.3002 9.89922C6.48353 10.0826 6.5752 10.3159 6.5752 10.5992C6.5752 10.8826 6.48353 11.1159 6.3002 11.2992C6.11686 11.4826 5.88353 11.5742 5.6002 11.5742C5.31686 11.5742 5.08353 11.4826 4.9002 11.2992L0.300196 6.69922C0.200196 6.59922 0.129195 6.49089 0.0871954 6.37422C0.0458621 6.25755 0.0251951 6.13255 0.0251951 5.99922C0.0251951 5.86589 0.0458621 5.74089 0.0871954 5.62422C0.129195 5.50755 0.200196 5.39922 0.300196 5.29922L4.9002 0.69922C5.08353 0.515886 5.31686 0.424218 5.6002 0.424218C5.88353 0.424218 6.11686 0.515886 6.3002 0.69922Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default LeftMarkIcon
